"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var retrieveFromLocalStorage = function retrieveFromLocalStorage(label) {
  // Retrieve the object from storage
  var retrievedString = localStorage.getItem(label);
  var retrievedObject = JSON.parse(retrievedString);
  return retrievedObject;
};

exports.default = retrieveFromLocalStorage;